import {GardenPlanService} from "@/app/plans/garden/services/garden.plan.service"


const initPlanData = {
  type:'garden',
  name: null,
  device_id: null,
  camps: null,
  camp_leave: null,
  camp_back: null,

  fill_areas:null,
  irrigation:[],
  tanks: [],
 // irrigation: null,
 // irrigation_distance: null,
 // irrigation_duration: null,
  work_days: [],
}


const initialState = () => {
  return {
    loading: false,
    errors: {},
    data: Object.assign({}, initPlanData)
  }
}


const state = initialState()

const mutations = {

  RESET_STORE_DATA(state) {
    Object.assign(state, { ...initialState() })
  },

  REQUEST_SEND (state) {
   
    Object.assign(state, {
      loading: true,
      errors: {}
    })
  },

  REQUEST_FINISHED (state) {
    Object.assign(state, {
      loading: false,
    })
  },


  SET_PLAN_DATA(state, data) {
  
    Object.assign(state.data, {
      ...data,
      fill_areas: data.data.fill_areas,
      camps:data.data.camps,
      irrigation:data.data.irrigation,
      tanks: data.data.tanks,
     // irrigation: data.data.irrigation,
     // irrigation_distance: data.data.irrigation_distance,
     // irrigation_duration: data.data.irrigation_duration,
      work_days: data.data.work_days,
    })

    delete state.data.data
    
  },

  RESET_REPEATER_FORM (state) {
    Object.assign(state.data, {
      
      irrigation:[],
      tanks: []
    })
  },

  REQUEST_SUCCESS (state) {
    Object.assign(state, {
      data:  Object.assign({}, initPlanData),
      errors: {},
      loading: false
    })
  },

  REQUEST_ERROR (state, error) {
    Object.assign(state, {
      errors: error,
      loading: false
    })
  },

  SET_FILL_AREAS ( state, data) {
    Object.assign(state.data, {
      fill_areas: data
    })
  },
  SET_Irrigation_AREAS(state,data){
    
    Object.assign(state.data, {
      irrigation: data
    })
  },
  SET_TANK_AREAS ( state, data) {
    Object.assign(state.data, {
      tanks: data
    })
  },

}


const actions = {

  createPlan(context) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      GardenPlanService.createPlan(context.state.data).then(res => {
        context.commit('REQUEST_SUCCESS')
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },


  updatePlan(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      GardenPlanService.updatePlan(id, context.state.data).then(res => {
        context.commit('REQUEST_FINISHED')
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },

  getPlan(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      GardenPlanService.getPlanById(id).then(res => {
       
        context.commit('REQUEST_SUCCESS')
        context.commit('SET_PLAN_DATA', res)
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },

  deletePlan(context, id,PlanType) {
    return new Promise((resolve, reject) => {
      GardenPlanService.deletePlan(id,PlanType).then(res => resolve(res))
        .catch(reason => reject(reason))
    })
  },

}




export default {
  namespaced: true,
  state,
  mutations,
  actions
};
